const Toggler = ({ name, action, value, }) => {
    return (
        <div className="mt-1">
            <label className="switch">
                <input name={name} type="checkbox" onChange={action} checked={value === 1} />
                <span className="slider round"></span>
            </label>
        </div>
    )
}
export default Toggler